import { useEffect, useState } from 'react';
import { getMyPaymentOptions } from '../services/customerMembershipService';

/**
 * Whether the signed-in customer may pay online at this store. Stays true until the answer
 * arrives and when it cannot be read: the server refuses an online payment it does not allow,
 * so this only decides which options are shown.
 */
const useCustomerOnlinePayments = (storeId, enabled = true) => {
  const [onlinePaymentsAllowed, setOnlinePaymentsAllowed] = useState(true);

  useEffect(() => {
    if (!storeId || !enabled) {
      setOnlinePaymentsAllowed(true);
      return undefined;
    }

    let cancelled = false;
    getMyPaymentOptions(storeId)
      .then((options) => {
        if (!cancelled) setOnlinePaymentsAllowed(options.onlinePaymentsAllowed);
      })
      .catch(() => {
        if (!cancelled) setOnlinePaymentsAllowed(true);
      });

    return () => { cancelled = true; };
  }, [storeId, enabled]);

  return onlinePaymentsAllowed;
};

export default useCustomerOnlinePayments;
